import {RouterPath} from './utils'

/** 주문서 Root */
const ORDER_ROOT = '/order'
const ORDER_CHECKOUT = `${ORDER_ROOT}/checkout`
const ORDER_POPUP = `${ORDER_ROOT}/popup`
const FAMILY_USER_ROOT = `${ORDER_ROOT}/familyPay`

const PURCHASE_CONFIRMATION_ROOT = `${ORDER_ROOT}/purchaseDecision`

const ORDER_DETAIL_ROOT = `${ORDER_ROOT}/status`

const Order = RouterPath.create(ORDER_ROOT)
const OrderResult = RouterPath.create(Order, 'result')
const OrderCommon = RouterPath.create(Order, 'common')
const OrderFamilyPay = RouterPath.create(Order, 'familyPay')
const OrderDetail = RouterPath.create(Order, 'status')
const OrderPurchaseConfirmation = RouterPath.create(Order, 'purchaseDecision')
const OrderCoupon = RouterPath.create(Order, 'coupon')
const OrderPaymentMethods = RouterPath.create(Order, 'paymentMethod')
const OrderSale = RouterPath.create(Order, 'sale')
const OrderSaleHistory = RouterPath.create(OrderSale, 'history')
const OrderSaleSettlement = RouterPath.create(OrderSale, 'settlement')
const OrderMerchant = RouterPath.create(Order, 'merchant')
const Delivery = RouterPath.create(Order, 'delivery')
const DeliveryTracking = RouterPath.create(Delivery, 'tracking')
const OrderBookParcelPickup = RouterPath.create(Order, 'bookParcelPickup')
const DeliveryInstruction = RouterPath.create(Order, 'deliveryInstruction')
const Claim = RouterPath.create(Order, 'claim')

/** 주문승인 */
export const ROUTER_ORDER_CHECK_OUT = {
    MAIN: `${ORDER_CHECKOUT}`,
    MALL: `${ORDER_CHECKOUT}/mall`,
    EASY_BOOKING: `${ORDER_CHECKOUT}/easybooking`,
    LOCAL_PAY: `${ORDER_CHECKOUT}/localpay`,
    BLOG: `${ORDER_CHECKOUT}/blog`,
    SELLER: `${ORDER_CHECKOUT}/seller`,
}

/** 주문승인 */
export const ROUTER_ORDER_APPLY = {
    MAIN: `${ORDER_ROOT}/apply`,
    MALL: `${ORDER_ROOT}/apply/mall`,
    EASY_BOOKING: `${ORDER_ROOT}/apply/easybooking`,
    LOCAL_PAY: `${ORDER_ROOT}/apply/localpay`,
    BLOG: `${ORDER_ROOT}/apply/blog`,
}

/** 주문실패 */
export const ROUTER_ORDER_FAIL = {
    MAIN: `${ORDER_ROOT}/fail`,
    MALL: `${ORDER_ROOT}/fail/mall`,
    EASY_BOOKING: `${ORDER_ROOT}/fail/easybooking`,
    LOCAL_PAY: `${ORDER_ROOT}/fail/localpay`,
    BLOG: `${ORDER_ROOT}/fail/blog`,
}

/** 주문완료 */
export const ROUTER_ORDER_RESULT = {
    MAIN: OrderResult,
    MALL: RouterPath.create(OrderResult, 'mall'),
    EASY_BOOKING: RouterPath.create(OrderResult, 'easybooking'),
    LOCAL_PAY: RouterPath.create(OrderResult, 'localpay'),
    BLOG: RouterPath.create(OrderResult, 'blog'),
    SELLER: RouterPath.create(OrderResult, 'seller'),
    FLEA_MARKET: RouterPath.create(OrderResult, 'fleamarket'),
}

/** 패밀리 결제 */
export const ROUTER_ORDER_FAMILY_PAY = {
    MAIN: OrderFamilyPay,
    /** 패밀리 결제 동의 */
    AGREE: RouterPath.create(OrderFamilyPay, '/agree'),
    /** 패밀리 결제 동의 결과 */
    AGREE_RESULT: RouterPath.create(OrderFamilyPay, '/agree/result'),
    /** 패밀리 결제 대표 개인정보 제공동의 */
    AGREE_ORGANIZER: RouterPath.create(OrderFamilyPay, '/agree/organizer'),
    /** 패밀리 결제 맴버 개인정보 제공동의 */
    AGREE_MEMBER: RouterPath.create(OrderFamilyPay, '/agree/member'),
    /** 개인정보 수집 및 이용 동의 */
    AGREE_PERSONAL: RouterPath.create(OrderFamilyPay, '/agree/personal'),
    /** 개인정보 제 3자 제공 동의 (네이버) */
    AGREE_THIRD_PEOPLE: RouterPath.create(OrderFamilyPay, '/agree/thirdPeople'),
    /** 개인정보 제 3자 제공 동의 */
    AGREE_MEMBER_THIRD_PEOPLE: RouterPath.create(OrderFamilyPay, '/agree/member/thirdPeople'),
    /** 패밀리 결제 서비스 이용동의 */
    AGREE_SERVICE: RouterPath.create(OrderFamilyPay, '/agree/service'),
    /** 패밀리 결제 철회 */
    WITHDRAW: RouterPath.create(OrderFamilyPay, '/withdraw'),
}

/**
 * 패밀리 결제 대표 서비스
 * @Deprecated
 **/
export const ROUTER_ORDER_FAMILY_PAY_USER = {
    ROOT: FAMILY_USER_ROOT,
    /** 패밀리 결제 동의 */
    AGREE: `${FAMILY_USER_ROOT}/agree`,
    /** 패밀리 결제 동의 결과 */
    AGREE_RESULT: `${FAMILY_USER_ROOT}/agree/result`,
    /** 패밀리 결제 대표 개인정보 제공동의 */
    AGREE_ORGANIZER: `${FAMILY_USER_ROOT}/agree/organizer`,
    /** 패밀리 결제 맴버 개인정보 제공동의 */
    AGREE_MEMBER: `${FAMILY_USER_ROOT}/agree/member`,
    /** 개인정보 수집 및 이용 동의 */
    AGREE_PERSONAL: `${FAMILY_USER_ROOT}/agree/personal`,
    /** 개인정보 제 3자 제공 동의 (네이버) */
    AGREE_THIRD_PEOPLE: `${FAMILY_USER_ROOT}/agree/thirdPeople`,
    /** 개인정보 제 3자 제공 동의 */
    AGREE_MEMBER_THIRD_PEOPLE: `${FAMILY_USER_ROOT}/agree/member/thirdPeople`,
    /** 패밀리 결제 서비스 이용동의 */
    AGREE_SERVICE: `${FAMILY_USER_ROOT}/agree/service`,
    /** 패밀리 결제 철회 */
    WITHDRAW: `${FAMILY_USER_ROOT}/withdraw`,
}

/** POPUP */
export const ROUTER_ORDER_POP_UP = {
    MAIN: `${ORDER_POPUP}`,
    DELIVERY_ADDRESSES: `${ORDER_POPUP}/deliveryAddresses`,
    NON_PURCHASABLE_PRODUCTS: `${ORDER_POPUP}/nonPurchasableProducts`,
    PIN_PAY_PASS_CHANGE: `${ORDER_POPUP}/pinPayPassChange`,
    PIN_PAY_PASS_CLOSE: `${ORDER_POPUP}/pinPayPassClose`,
    /** 주문서 Popup 에서 결과를 opener 로 전달받는 BridgePage */
    BRIDGE: `${ORDER_ROOT}/popupBridge`,
}

/** 주문서연동 */
export const ROUTER_ORDER_BRIDGE = `${ORDER_ROOT}/bridge`

/** FDS 결과 연동 */
export const ROUTER_ORDER_FDS_AUTH_BRIDGE = `${ORDER_ROOT}/fdsbridge`

/** 배송조회 */
export const ROUTER_ORDER_DELIVERY_TRACKING = {
    ROOT: DeliveryTracking,
}

/** 배송지 */
export const ROUTER_ORDER_DELIVERY = {
    /** 배송지 목록 조회/관리 */
    DELIVERY: `${ORDER_ROOT}/delivery`,
    /** 주문완료 배송지 변경 조회/관리 */
    DELIVERY_ORDER_RESULT: `${ORDER_ROOT}/delivery/orderResult`,
    /** 주문완료 배송지 변경 조회/관리 */
    DELIVERY_SCHEDULED_ORDER_RESULT: `${ORDER_ROOT}/delivery/scheduledOrderResult`,
    /** 로그인 미필요 우편번호 검색 */
    ZIPCODE: `${ORDER_ROOT}/zipcode`,
}

export const ROUTER_ORDER_COMMON = {
    MAIN: OrderCommon,
    /** 배송지 관리 */
    AUTH: RouterPath.create(OrderCommon, 'auth'),
}

/** 주문상세 */
export const ROUTER_ORDER_DETAIL = {
    MAIN: OrderDetail,
    /** popup bridge */
    POPUP_BRIDGE: RouterPath.create(OrderDetail, 'popupBridge'),
    ROOT: ORDER_DETAIL_ROOT,
}

/** 구매확정 */
export const ROUTER_ORDER_PURCHASE_CONFIRMATION = {
    MAIN: OrderPurchaseConfirmation,
    /** 구매확정완료 */
    RESULT: RouterPath.create(OrderPurchaseConfirmation, 'result'),
    /** 브릿지 */
    BRIDGE: RouterPath.create(OrderPurchaseConfirmation, 'bridge'),
}

/** 판매자 */
export const ROUTER_ORDER_MERCHANT = {
    MAIN: OrderMerchant,
    INFO: RouterPath.create(OrderMerchant, 'info'),
}

/** 수령위치/출입방법 설정 페이지 */
export const ROUTER_DELIVERY_INSTRUCTION = {
    MAIN: DeliveryInstruction,
}

/**
 * 구매확정
 * @Deprecated
 **/
export const ROUTER_ORDER_PURCHASE_CONFIRMATIONS = {
    ROOT: PURCHASE_CONFIRMATION_ROOT,
    /** 구매확정완료 */
    RESULT: `${PURCHASE_CONFIRMATION_ROOT}/result`,
    /** 브릿지 */
    BRIDGE: `${PURCHASE_CONFIRMATION_ROOT}/bridge`,
}

/** 판매 */
export const ROUTER_ORDER_SALE_HISTORY = {
    MAIN: RouterPath.create(OrderSaleHistory),
    /** 판매내역 상세 */
    DETAIL: RouterPath.create(OrderSaleHistory),
    /** 판매내역 검색 */
    SEARCH: RouterPath.create(OrderSaleHistory, 'search'),
    /** 판매내역 취소거부 */
    CANCEL_REJECT: RouterPath.create(OrderSaleHistory, 'cancel/reject'),
    /** 판매내역 판매거부 */
    CANCEL_SALE: RouterPath.create(OrderSaleHistory, 'cancel/sale'),
    /** 판매내역 발송처리 */
    DELIVERY_DISPATCH: RouterPath.create(OrderSaleHistory, 'delivery/dispatch'),
    /** 방문택배예약 > 발송처리 */
    BOOK_PARCEL_PICKUP_DELIVERY_DISPATCH: RouterPath.create(OrderSaleHistory, 'bookParcelPickup/delivery/dispatch'),
    /** 방문택배예약(취소거부) > 발송처리(취소거부) */
    BOOK_PARCEL_PICKUP_CANCEL_REJECT: RouterPath.create(OrderSaleHistory, 'bookParcelPickup/cancel/reject'),
    /** 판매내역 반품승인 */
    RETURN_ADMISSION: RouterPath.create(OrderSaleHistory, 'return/admission'),
    /** 판매내역 반품거절 */
    RETURN_REJECT: RouterPath.create(OrderSaleHistory, 'return/reject'),
}

/** 정산 */
export const ROUTER_ORDER_SALE_SETTLEMENT = {
    MAIN: RouterPath.create(OrderSaleSettlement),
    /** 정산내역 상세 */
    DETAIL: RouterPath.create(OrderSaleSettlement),
    /** 정산내역 지급보류 */
    PAY_HOLD: RouterPath.create(OrderSaleSettlement, 'pay/hold'),
    /** 정산내역 검색 */
    SEARCH: RouterPath.create(OrderSaleSettlement, 'search'),
}

/** 쿠폰 사용 설정 변경 */
export const ROUTER_ORDER_COUPON = {
    ROOT: OrderCoupon,
}
/** 결제수단 변경 */
export const ROUTER_ORDER_PAYMENT_METHODS = {
    ROOT: OrderPaymentMethods,
}

/** 방문택배예약 */
export const ROUTER_ORDER_BOOK_PARCEL_PICKUP = {
    ROOT: OrderBookParcelPickup,
}

/** 클레임 페이지 */
export const ROUTER_ORDER_CLAIM = {
    ROOT: Claim,
    /** 요청 페이지 */
    REQUEST: {
        ROOT: RouterPath.create(Claim, 'request'),
    },
    /** 수거 페이지 */
    COLLECT: {
        ROOT: RouterPath.create(Claim, 'collect'),
    },
    /** 결제 페이지 */
    PAYMENT: {
        ROOT: RouterPath.create(Claim, 'payment'),
    },
    /** 완료 페이지 */
    RESULT: {
        ROOT: RouterPath.create(Claim, 'result'),
    },
    /** 상세 페이지 */
    DETAIL: {
        ROOT: RouterPath.create(Claim, 'detail'),
    },
}
